import React from 'react'

import { useNotificationsHomeContext } from '../../context'
import { Button } from '../../../components'
import { useInAppNotificationStyles } from '../../../hooks/styles/useInAppNotificationStyles'
import { useBaseStyles } from '../../../hooks/styles/useBaseStyles'
import MemoReply from '../Icons/Reply'
import MemoOpenInNew from '../Icons/OpenInNew'

const ActionButton = ({ button, item }) => {
  const {
    handlers: { handleMarkAsRead }
  } = useNotificationsHomeContext()

  const { FlexBox } = useBaseStyles()

  const sameTab = button?.sameTab || 'false'
  const target = sameTab === 'false' ? '_blank' : '_self'
  const variant = button?.primary === 'true' ? 'contained' : 'outlined'
  const buttonType = button?.type

  const handleClick = (e) => {
    e.stopPropagation()

    handleMarkAsRead(item)
    if (sameTab === 'true') {
      window.open(button?.url, '_self')
    } else {
      window.open(button?.url, '_blank')
    }
  }

  return (
    <a
      target={target}
      href={`${button?.action}`}
      style={{ textDecoration: 'none' }}
      onClick={(e) => handleClick(e)}
      rel='noreferrer'
    >
      <Button variant={variant} size='small' sx={{ fontSize: '0.6rem' }}>
        <FlexBox style={{ gap: '5px' }}>
          {buttonType === 'reply' && <MemoReply />} {button?.label}{' '}
          {buttonType === 'url' && <MemoOpenInNew variant={variant} />}
        </FlexBox>
      </Button>
    </a>
  )
}

export const NotificationActionButtons = ({ item }) => {
  const { NotificationContentActionButtonsContainer } =
    useInAppNotificationStyles()

  const buttons = item?.notification_content?.buttons

  if (buttons?.length > 0) {
    return (
      <NotificationContentActionButtonsContainer>
        {buttons.map((button, index) => {
          return (
            <ActionButton
              key={button?.label + index}
              button={button}
              item={item}
            />
          )
        })}
      </NotificationContentActionButtonsContainer>
    )
  } else return null
}
